function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/converters/upcasttable
 */
import { createEmptyTableCell } from '../utils/common';
import { first } from 'ckeditor5/src/utils';
/**
 * Returns a function that converts the table view representation:
 *
 *		<figure class="table"><table>...</table></figure>
 *
 * to the model representation:
 *
 *		<table></table>
 *
 * @returns {Function}
 */

export function upcastTableFigure() {
  return function (dispatcher) {
    dispatcher.on('element:figure', function (evt, data, conversionApi) {
      // Do not convert if this is not a "table figure".
      if (!conversionApi.consumable.test(data.viewItem, {
        name: true,
        classes: 'table'
      })) {
        return;
      } // Find an table element inside the figure element.


      var viewTable = getViewTableFromFigure(data.viewItem); // Do not convert if table element is absent or was already converted.

      if (!viewTable || !conversionApi.consumable.test(viewTable, {
        name: true
      })) {
        return;
      } // Convert view table to model table.


      var conversionResult = conversionApi.convertItem(viewTable, data.modelCursor); // Get table element from conversion result.

      var modelTable = first(conversionResult.modelRange.getItems()); // When table wasn't successfully converted then finish conversion.

      if (!modelTable) {
        return;
      }

      conversionApi.convertChildren(data.viewItem, conversionApi.writer.createPositionAt(modelTable, 'end'));
      conversionApi.updateConversionResult(modelTable, data);
    });
  };
}
/**
 * View table element to model table element conversion helper.
 *
 * This conversion helper converts the table element as well as table rows.
 *
 * @returns {Function} Conversion helper.
 */

export default function upcastTable() {
  return function (dispatcher) {
    dispatcher.on('element:table', function (evt, data, conversionApi) {
      var viewTable = data.viewItem; // When element was already consumed then skip it.

      if (!conversionApi.consumable.test(viewTable, {
        name: true
      })) {
        return;
      }

      var _scanTable = scanTable(viewTable),
          rows = _scanTable.rows,
          headingRows = _scanTable.headingRows,
          headingColumns = _scanTable.headingColumns; // Only set attributes if values is greater then 0.


      var attributes = {};

      if (headingColumns) {
        attributes.headingColumns = headingColumns;
      }

      if (headingRows) {
        attributes.headingRows = headingRows;
      }

      var table = conversionApi.writer.createElement('table', attributes);

      if (!conversionApi.safeInsert(table, data.modelCursor)) {
        return;
      }

      conversionApi.consumable.consume(viewTable, {
        name: true
      }); // Upcast table rows in proper order (heading rows first).

      rows.forEach(function (row) {
        return conversionApi.convertItem(row, conversionApi.writer.createPositionAt(table, 'end'));
      }); // Convert everything else.

      conversionApi.convertChildren(viewTable, conversionApi.writer.createPositionAt(table, 'end')); // Create one row and one table cell for empty table.

      if (table.isEmpty) {
        var row = conversionApi.writer.createElement('tableRow');
        conversionApi.writer.insert(row, conversionApi.writer.createPositionAt(table, 'end'));
        createEmptyTableCell(conversionApi.writer, conversionApi.writer.createPositionAt(row, 'end'));
      }

      conversionApi.updateConversionResult(table, data);
    });
  };
}
/**
 * A conversion helper that skips empty <tr> elements from upcasting at the beginning of the table.
 *
 * An empty row is considered a table model error but when handling clipboard data there could be rows that contain only row-spanned cells
 * and empty TR-s are used to maintain the table structure (also {@link module:table/tablewalker~TableWalker} assumes that there are only
 * rows that have related `tableRow` elements).
 *
 * *Note:* Only the first empty rows are removed because they have no meaning and it solves the issue
 * of an improper table with all empty rows.
 *
 * @returns {Function} Conversion helper.
 */

export function skipEmptyTableRow() {
  return function (dispatcher) {
    dispatcher.on('element:tr', function (evt, data) {
      if (data.viewItem.isEmpty && data.modelCursor.index == 0) {
        evt.stop();
      }
    }, {
      priority: 'high'
    });
  };
}
/**
 * A converter that ensures an empty paragraph is inserted in a table cell if no other content was converted.
 *
 * @returns {Function} Conversion helper.
 */

export function ensureParagraphInTableCell(elementName) {
  return function (dispatcher) {
    dispatcher.on("element:".concat(elementName), function (evt, data, conversionApi) {
      // The default converter will create a model range on converted table cell.
      if (!data.modelRange) {
        return;
      } // Ensure a paragraph in the model for empty table cells for converted table cells.


      if (data.viewItem.isEmpty) {
        var tableCell = data.modelRange.start.nodeAfter;
        var modelCursor = conversionApi.writer.createPositionAt(tableCell, 0);
        conversionApi.writer.insertElement('paragraph', modelCursor);
      }
    }, {
      priority: 'low'
    });
  };
} // Get view `<table>` element from the view widget (`<figure>`).
//
// @private
// @param {module:engine/view/element~Element} figureView
// @returns {module:engine/view/element~Element}

function getViewTableFromFigure(figureView) {
  var _iterator = _createForOfIteratorHelper(figureView.getChildren()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var figureChild = _step.value;

      if (figureChild.is('element', 'table')) {
        return figureChild;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
} // Scans table rows and extracts required metadata from the table:
//
// headingRows    - The number of rows that go as table headers.
// headingColumns - The maximum number of row headings.
// rows           - Sorted `<tr>` elements as they should go into the model - ie. if `<thead>` is inserted after `<tbody>` in the view.
//
// @private
// @param {module:engine/view/element~Element} viewTable
// @returns {{headingRows, headingColumns, rows}}


function scanTable(viewTable) {
  var tableMeta = {
    headingRows: 0,
    headingColumns: 0
  }; // The `<tbody>` and `<thead>` sections in the DOM do not have to be in order `<thead>` -> `<tbody>` and there might be more than one
  // of them.
  // As the model does not have these sections, rows from different sections must be sorted.
  // For example, below is a valid HTML table:
  //
  //		<table>
  //			<tbody><tr><td>2</td></tr></tbody>
  //			<thead><tr><td>1</td></tr></thead>
  //			<tbody><tr><td>3</td></tr></tbody>
  //		</table>
  //
  // But browsers will render rows in order as: 1 as the heading and 2 and 3 as the body.

  var headRows = [];
  var bodyRows = []; // Currently the editor does not support more then one <thead> section.
  // Only the first <thead> from the view will be used as a heading row and the others will be converted to body rows.

  var firstTheadElement;

  for (var _i = 0, _Array$from = Array.from(viewTable.getChildren()); _i < _Array$from.length; _i++) {
    var tableChild = _Array$from[_i];

    // Only `<thead>`, `<tbody>` & `<tfoot>` from allowed table children can have `<tr>`s.
    // The else is for future purposes (mainly `<caption>`).
    if (tableChild.name === 'tbody' || tableChild.name === 'thead' || tableChild.name === 'tfoot') {
      // Save the first `<thead>` in the table as table header - all other ones will be converted to table body rows.
      if (tableChild.name === 'thead' && !firstTheadElement) {
        firstTheadElement = tableChild;
      } // There might be some extra empty text nodes between the `<tr>`s.
      // Make sure further code operates on `tr`s only. (#145)


      var trs = Array.from(tableChild.getChildren()).filter(function (el) {
        return el.is('element', 'tr');
      });

      var _iterator2 = _createForOfIteratorHelper(trs),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tr = _step2.value;

          // This <tr> is a child of a first <thead> element.
          if (tr.parent.name === 'thead' && tr.parent === firstTheadElement) {
            tableMeta.headingRows++;
            headRows.push(tr);
          } else {
            bodyRows.push(tr); // For other rows check how many column headings this row has.

            var headingCols = scanRowForHeadingColumns(tr, tableMeta, firstTheadElement);

            if (headingCols > tableMeta.headingColumns) {
              tableMeta.headingColumns = headingCols;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }

  tableMeta.rows = [].concat(headRows, bodyRows);
  return tableMeta;
} // Scans a `<tr>` element and its children for metadata:
// - For heading row:
//     - Adds this row to either the heading or the body rows.
//     - Updates the number of heading rows.
// - For body rows:
//     - Calculates the number of column headings.
//
// @private
// @param {module:engine/view/element~Element} tr
// @returns {Number}


function scanRowForHeadingColumns(tr) {
  var headingColumns = 0;
  var index = 0; // Filter out empty text nodes from tr children.

  var children = Array.from(tr.getChildren()).filter(function (child) {
    return child.name === 'th' || child.name === 'td';
  }); // Count starting adjacent <th> elements of a <tr>.

  while (index < children.length && children[index].name === 'th') {
    var th = children[index]; // Adjust columns calculation by the number of spanned columns.

    var colspan = parseInt(th.getAttribute('colspan') || 1);
    headingColumns = headingColumns + colspan;
    index++;
  }

  return headingColumns;
}